import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { lerp } from '@/utils/math'

export default function AudioManager() {
  const { currentIndex, items, mode } = useSelector((state) => state.progress)

  // Music
  const musicAudios = []

  for (let i = 1; i <= items.length; i++) {
    const audio = new Audio(`/music/${i}.mp3`)
    audio.volume = 0
    audio.load()

    const tryToPlay = () => {
      audio
        .play()
        .then(() => {
          clearInterval(intervalId)
          return audio
        })
        .catch((error) => {})
    }

    const intervalId = setInterval(tryToPlay, 5000)
    musicAudios.push(audio)

    audio.addEventListener('ended', () => {
      audio.currentTime = 0
      tryToPlay.play()
    })
  }

  useEffect(() => {
    if (currentIndex === 0) return
    smoothFade(musicAudios[currentIndex - 1], 0.015, 5000)
  }, [currentIndex])

  function loadAudio(index) {
    const audio = new Audio(`/voiceover/${index}.mp3`)
    audio.volume = 0.8
    audio.load()

    audio.addEventListener('ended', () => {
      const event = new Event('audioEnd')
      document.dispatchEvent(event)
    })

    voiceoverAudios[index] = audio
  }

  // Voiceover
  const voiceoverAudios = []

  useEffect(() => {
    if (mode !== 'inspection') return
    for (let i = 0; i < items.length; i++) {
      loadAudio(i)
    }

    voiceoverAudios[currentIndex].play()

    // Clean up
    return () => {
      voiceoverAudios.forEach((audio) => {
        audio.removeEventListener('ended', () => {})
      })
    }
  }, [mode])

  function smoothFade(audio, targetVolume, duration) {
    const startVolume = audio.volume
    let startTime

    function update(currentTime) {
      if (!startTime) startTime = currentTime

      const elapsed = currentTime - startTime
      const progress = elapsed / duration

      audio.volume = lerp(startVolume, targetVolume, progress)

      if (elapsed < duration) {
        requestAnimationFrame(update)
      } else {
        audio.volume = targetVolume
      }
    }

    requestAnimationFrame(update)
  }
}
